module.exports = __webpack_public_path__ + "static/media/economy.772384a7.png";